import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Multi Dropdown icon — pair of downward chevrons.
 * Uses `stroke="currentColor"` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const MultiDropdownIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M14 10.1387L10.4714 13.6673C10.2111 13.9276 9.78894 13.9276 9.5286 13.6673L6 10.1387M14 6.13867L10.4714 9.66727C10.2111 9.92762 9.78894 9.92762 9.5286 9.66727L6 6.13867"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export default MultiDropdownIcon;
